import { EmptySpaceFiller, GroupLabel } from './SharedGroupRuleElements';
import { GroupType } from '@ardoq/api-types';
import { t, type WithI18nLocale } from '@ardoq/i18n';

type ComponentTypeGroupRuleProps = WithI18nLocale;

const ComponentTypeGroupRule = ({
  i18nLocale,
}: ComponentTypeGroupRuleProps) => {
  return (
    <>
      <GroupLabel data-testid={`group-by-${GroupType.COMPONENT}-label`}>
        {t(
          i18nLocale,
          'perspectives:groupingRules.componentTypesLabel',
          'Component Types'
        )}
      </GroupLabel>
      <EmptySpaceFiller />
    </>
  );
};

export { ComponentTypeGroupRule };
